import { useSelector } from "react-redux";

import { resolveDesignTimeValueSelector } from "./valueSelectors.ts";

/**
 * Live design-time resolution over designer state: re-computes as the
 * producing nodes' configs change, so builder summary/edit views stay current.
 */
export const useResolveDesignTimeValue = () => useSelector(resolveDesignTimeValueSelector);
